/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsshareevent2Inputs */

const en_groupsshareevent2 = /** @type {(inputs: Groupsshareevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share event`)
};

const de_groupsshareevent2 = /** @type {(inputs: Groupsshareevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event teilen`)
};

/**
* | output |
* | --- |
* | "Share event" |
*
* @param {Groupsshareevent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsshareevent2 = /** @type {((inputs?: Groupsshareevent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsshareevent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsshareevent2(inputs)
	return de_groupsshareevent2(inputs)
});
export { groupsshareevent2 as "groupsShareEvent" }